module.exports = __webpack_public_path__ + "img/main.70495e7a.png";